import { not } from '@hcr/utils'

import { isUndefinedOrEmptyPathParam } from './isUndefinedOrEmptyPathParam'

export const isNotUndefinedOrEmptyPathParam = not(isUndefinedOrEmptyPathParam)
